<template>
  <div
    class="time-picker"
    ref="container"
    v-on:focusout="blurInput"
  >
    <label>
      <input
        class="time-picker__input"
        type="text"
        inputmode="numeric"
        v-bind:disabled="disabled"
        v-mask="$options.maskTime"
        v-model="input"
        v-on:focus="selectInput"
      />
    </label>
    <div
      class="time-picker__drawer"
      v-if="selectedInput && items.length">
      <button
        type="button"
        v-for="(item, key) in items"
        :key="key"
        v-on:mousedown="chooseTime(item)"
        class="time-picker__drawer__item"
      >
        {{ item }}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Компонент выбора времени из множества
 * @type {Vue}
 */
export default {
  name: 'TimePicker',
  data() {
    return {
      input: this.value,
      selectedInput: false,
    };
  },
  methods: {
    chooseTime(item) {
      this.input = item;
      this.blurInput();
    },
    selectInput() {
      this.selectedInput = true;
    },
    /**
     * При потери фокуса внутри нашего компонента прячем пикер
     * @param {FocusEvent} e
     */
    blurInput(e = null) {
      if (e) {
        if (e.relatedTarget && this.$refs.container.contains(e.relatedTarget)) {
          return;
        }
      }
      this.selectedInput = false;
    },
  },
  watch: {
    input(value) {
      this.$emit('input', value);
    },
  },
  maskTime: '##:##',
  props: {
    /**
     * @description Набор времен, формируется специфично в родительском компоненте.
     * @type {string[]}
     */
    items: { required: true, type: Array },
    /**
     * @description Время.
     * @type {string}
     */
    value: { required: true, type: String },
    /**
     * @description Деактивировать.
     * @type {boolean}
     */
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.time-picker {
  position: relative;
  &__input {
    border: 1px solid #C2CFE0;
    box-sizing: border-box;
    border-radius: 4px;
    height: 40px;
    width: 100%;
    min-width: 65px;
    padding: 10px;
    color: #707683;
    font-size: 16px;
    &:focus {
      color: #192a3e;
      background-color: #fff;
      border: 1px solid #0489e0 !important;
      outline: 0;
    }
    &:disabled {
      background-color: #fff;
    }
  }
  &__drawer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: absolute;
    right: 0;
    left: 0;
    background: white;
    border: 1px solid #C2CFE0;
    border-radius: 0 0 4px 4px;
    padding: 0;
    overflow-y: scroll;
    max-height: 123px;
    z-index: 10;
    &__item {
      color: #707683;
      font-size: 14px;
      padding: 10px;
      width: 100%;
      text-align: left;
      &:hover {
        color: #0489e0;
      }
    }
  }
}

</style>
